module.exports = __webpack_public_path__ + "img/breadboard_lcd_connectors.06a12ce3.png";